import { render, staticRenderFns } from "./ProposalSearch.vue?vue&type=template&id=08299e42"
import script from "./ProposalSearch.vue?vue&type=script&lang=js"
export * from "./ProposalSearch.vue?vue&type=script&lang=js"
import style0 from "./ProposalSearch.vue?vue&type=style&index=0&id=08299e42&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports